<template>
  <div id="app" >
    <my-header  ></my-header>

    <router-view :key="$route.meta.key || $route.fullPath" class="scale-container" ></router-view>
      <my-footer ></my-footer>
 </div>
</template>

<script>
import myHeader from '@/components/header.vue'
import myFooter from '@/components/footer.vue'

export default {
  name: 'App',
   components: {

    myHeader,
    myFooter
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/functions.scss";
// @media screen and (min-width: 968px) and (max-width: 1700px) {
//   body {
//     transform: scale(0.9);
//     transform-origin: 0 0;
//     width: 111.11%; 
//     /* 移除 height: 111.11% */
//     height: 100vh; /* 确保最小高度为视口高度 */
//     overflow-x: hidden;
//     margin: 0; /* 清除默认边距 */
//   }

// }
/* 替代方案 - 更推荐 */
@media screen and (min-width: 968px) and (max-width: 1700px) {
  .scale-container {
    transform: scale(0.9);
    transform-origin: 0 0;
    width: 111.11%;
    height: 100vh;
    overflow-x: hidden;
  }
  
  body {
    margin: 0;
    overflow: hidden;
  }
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.banxin {
  width: 1200px;
  margin: 0 auto;
}
.slide-image2 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.slide-image3 {


  transition: transform 0.3s ease; /* 平滑过渡效果 */


}

.slide-image3:hover {
  transform: scale(1.02); /* 鼠标悬停时放大 5% */

}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;

  transition: transform 0.3s ease; /* 平滑过渡效果 */


}

.slide-image:hover {
  transform: scale(1.02); /* 鼠标悬停时放大 5% */

}
.curPot{
  cursor: pointer;
}
.slide-image-canjue {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

 .typewriter {
    width: fit-content;
    overflow: hidden;
    border-right: 2px solid #000; /* 光标效果 */
    white-space: nowrap;
    animation: 
      typing 3s steps(30, end),
      blink-caret 0.5s step-end infinite;
  }

  @keyframes typing {
    from { width: 0 }
    to { width: 100% }
  }

  @keyframes blink-caret {
    from, to { border-color: transparent }
    50% { border-color: #000; }
  }









</style>